import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { NEW_USER_REFERRAL_REWARD } from '@src/constants/referral';
import actions from '@src/redux/actions';
import { StyledReferralBanner } from './index.style';

const ReferralBanner = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();
  const handleOpenRedeemReferralDialog = () => {
    dispatch(actions.user.updateIsOpeningRedeemReferralDialog(true));
  };

  return (
    <StyledReferralBanner
      useVoucherByProduct
      onClick={handleOpenRedeemReferralDialog}
    >
      <div className="banner-information">
        <div className="banner-content">
          {t('referralAds', {
            reward: NEW_USER_REFERRAL_REWARD.toLocaleString(language),
          })}
        </div>
      </div>
    </StyledReferralBanner>
  );
};

export default ReferralBanner;
